// bluetooth

const SET_INFODATA = 'SET_INFODATA'
const SET_CONNECTBLEDATA = 'SET_CONNECTBLEDATA'
const SET_CONNECTPRINTBLE = 'SET_CONNECTPRINTBLE'

export {
  SET_INFODATA,
  SET_CONNECTBLEDATA,
  SET_CONNECTPRINTBLE
}
